import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import hr from './locales/hr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import ar from './locales/ar.json';
import hi from './locales/hi.json';
import ru from './locales/ru.json';
import ja from './locales/ja.json';
import sl from './locales/sl.json';
import sk from './locales/sk.json';
import hu from './locales/hu.json';
import it from './locales/it.json';
import nl from './locales/nl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      hr: { translation: hr }, en: { translation: en }, de: { translation: de },
      es: { translation: es }, fr: { translation: fr }, pt: { translation: pt },
      zh: { translation: zh }, ar: { translation: ar }, hi: { translation: hi },
      ru: { translation: ru }, ja: { translation: ja },
      sl: { translation: sl }, sk: { translation: sk }, hu: { translation: hu },
      it: { translation: it }, nl: { translation: nl },
    },
    fallbackLng: 'hr',
    lng: (() => {
      // Deep-link support: ?lang=XX in the URL wins over stored preference
      // so shared translated pages open directly in the target language.
      try {
        const qs = new URLSearchParams(window.location.search);
        const q = (qs.get('lang') || '').trim().toLowerCase();
        const allowed = new Set(['hr','en','de','es','fr','pt','zh','ar','hi','ru','ja','sl','sk','hu','it','nl']);
        if (q && allowed.has(q)) {
          localStorage.setItem('emina_locale', q);
          return q;
        }
      } catch {}
      return localStorage.getItem('emina_locale') || 'hr';
    })(),
    detection: { lookupLocalStorage: 'emina_locale', order: ['localStorage'] },
    interpolation: { escapeValue: false },
    // Re-render React components on every event that can alter translations —
    // crucial for the runtime auto-translator that calls
    // `addResourceBundle(...)` AFTER the initial render.
    react: {
      bindI18n: 'languageChanged loaded added',
      bindI18nStore: 'added',
    },
  });

// Update html lang/dir on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// Kick off the runtime auto-translator. On every language change this
// pulls any still-missing key into the resource bundle via the backend
// translator (Gemini / LibreTranslate / Google — admin-configurable).
import('./autoTranslate').then(m => m.bootAutoTranslate()).catch(() => {});

export default i18n;
